export default __webpack_public_path__ + "static/media/48a307303f25790be9a07801991ba2f01581602304001.6bc33cf6.webp";